export type Purchase = {
  name: string
  city: string
  state: string
}

/** Compradores de MUESTRA para las notificaciones de compra reciente. */
export const recentPurchases: Purchase[] = [
  { name: 'Sarah M.', city: 'Austin', state: 'Texas' },
  { name: 'James K.', city: 'Leeds', state: 'England' },
  { name: 'Emily R.', city: 'Columbus', state: 'Ohio' },
  { name: 'Daniel T.', city: 'Vancouver', state: 'British Columbia' },
  { name: 'Olivia P.', city: 'Melbourne', state: 'Victoria' },
  { name: 'Mark S.', city: 'Charlotte', state: 'North Carolina' },
  { name: 'Rachel B.', city: 'Bristol', state: 'England' },
  { name: 'Kevin W.', city: 'Sacramento', state: 'California' },
  { name: 'Anita G.', city: 'Toronto', state: 'Ontario' },
  { name: 'Chris D.', city: 'Denver', state: 'Colorado' },
  { name: 'Lucy H.', city: 'Brisbane', state: 'Queensland' },
  { name: 'Paul L.', city: 'St. Louis', state: 'Missouri' },
]
